// extracted by mini-css-extract-plugin
export default {"root":"_1WU3z","tips":"_2W3EO"};